import React, { useEffect, useState } from "react";
import AssignedPatient from "./AssignedPatient";
import SectionCard from "../../generic/sectioncard/SectionCard";
import { MultiSelect } from "../../generic/elements/multiselect/MultiSelect";
import apiService from "../../../service/apiservice/apiService";
import { useGetOrgIdentifier } from "../../generic/hooks/useGetOrgIdentifier";
import NoDataMessageComponent from "../../../components/generic/nodatamessage/NoDataMessageComponent";
import { Spin } from "antd";

const options = [
  {
    label: "Current",
    value: "current",
  },
  {
    label: "Former",
    value: "former",
  },
];

const AssignedPatientsWrapper = ({ workforceIdentifier }) => {
  const organizationIdentifier = useGetOrgIdentifier();
  const [assignedPatients, setAssignedPatients] = useState([]);
  const [patientType, setPatientType] = useState(options);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getAssignedPatients = async () => {
      setLoading(true);

      const endpoint =
        "niramayafoundation/niramayaworkforce/v1/assignedPatient";
      const params = {
        organizationIdentifier,
        workforceIdentifier,
        patientType: patientType?.map((item) => item?.value)?.join(","),
      };

      const response = await apiService.get(endpoint, params);

      setAssignedPatients(response);
      setLoading(false);
    };

    getAssignedPatients();
  }, [patientType, workforceIdentifier, organizationIdentifier]);

  return (
    <SectionCard
      title="Assigned Patients"
      className="listCardStylingThirdRow assigned-patient-dropdown"
      action={
        <MultiSelect
          options={options}
          value={patientType}
          onChange={(value) => setPatientType(value)}
          placeholder="Select Patient Type"
          allLabel="All"
          width={190}
        />
      }
    >
      {loading ? (
        <Spin size="medium" className="spinnerCenter" />
      ) : (
        <>
          {!assignedPatients.length ? (
            <NoDataMessageComponent text="No Assigned Patients" />
          ) : (
            <div className="care-plan-card px-3">
              {assignedPatients?.map((patient) => {
                return (
                  <div
                    key={patient?.userIdentifier}
                    className="careplan-main-card-section card"
                  >
                    <AssignedPatient patient={patient} />
                  </div>
                );
              })}
            </div>
          )}
        </>
      )}
    </SectionCard>
  );
};

export default AssignedPatientsWrapper;
